import request from '../../src/state/modules/axios'

export function getLanguageLevels(){
    return request({
        url: '/api/language-level',
        method: 'get',
    })
}

export function getLangLevelById(data){
    return request({
        url: `/api/language-level/${data.id}`,
        method: 'get',
    })
}

export function addLanguageLevels(data){
    return request({
        url: '/api/language-level',
        method: 'post',
        data,
    })
}

export function editLanguageLevel(data){
    return request({
        url: `/api/language-level/${data.id}`,
        method: 'put',
        data,
    })
}


export function deleteLanguageLevels(data){
    return request({
        url: `/api/language-level/${data.id}`,
        method: 'delete'
    })
}